const initialState = {
	sidebarShow: true,
	sidebarUnfoldable: false,
	asideShow: false,
	theme: 'default',
	toast: 0,
};

const changeState = (state = initialState, { type, ...rest }) => {
	switch (type) {
		case 'set':
			return { ...state, ...rest };
		default:
			return { ...state };
	}
};

export default changeState;
